import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from '@lodash';
import { useState, useRef } from 'react';
import { showMessage } from 'app/store/fuse/messageSlice';
import { constants } from '../../../../../constants';
import RetroactiveUpdateModal from './RetroactiveUpdateModal';
import BillingHistory from './BillingHistory';
import SummaryModal from './SummaryModal';
import CommissionsOverrideModal from './CommissionsOverrideModal';
import { connect } from 'react-redux';
import client from 'client';
import FuseLoading from '@fuse/core/FuseLoading';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import JobAction from 'app/stores/loadz/redux/Jobs/actions'
import { hasPermission } from 'app/main/loadz/utils';
import CircularLoader from 'app/main/loadz/components/CircularLoader';
import ButtonLog from 'app/main/ButtonLog';
import {useTranslation} from 'react-i18next';

function fuelSurchargeWasModified(fuel) {
  if (!fuel?.enabled) return false;
  const initial = fuel.initial;
  if (!initial?.hasSaved) return true;
  return (
    Number(fuel.rate) !== Number(initial.rate) ||
    String(fuel.fsc_option_id ?? '') !== String(initial.fsc_option_id ?? '')
  );
}

function fuelSurchargeIsComplete(fuel) {
  const rate = Number(fuel?.rate);
  const fscOptionId = Number(fuel?.fsc_option_id);
  return Boolean(fscOptionId) && fuel?.rate !== '' && fuel?.rate != null && !Number.isNaN(rate);
}

function JobsHelpersFooterBilling({
  id,
  jsonGetById,
  deletespecial,
  job_billing_history,
  user,
  data,
  setJob_id,
  setEditJobBillingOpen,
  job_id,
  getPendingJobs,
  commissionMatrix = [],
  commissionMatrixChanged = false,
  autoInvoice,
  fuelSurchargeRef
}) {
  const dispatch = useDispatch();
  const methods = useFormContext();
  const [disabled, setDisabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [billingmessage, setBillingMessage] = useState('');
  const [changinginvoices, setChangingInvoices] = useState(0);
  const [billingchanges, setBillingChanges] = useState();
  const [jobinvoices, setJobInvoices] = useState([]);
  const [openconfirm, setOpenConfirm] = useState(false);
  const [SummaryOpen, setSummaryOpen] = useState(false);
  const [invoicesPrev, setInvoicesPrev] = useState(false);
  const [getData, setgetData] = useState(false);
  const { formState, watch, getValues, setError, reset, setValue } = methods;
  const history = useHistory();
  const [conditional,setConditional] = useState([])
  const [commissionsOverrideOpen, setCommissionsOverrideOpen] = useState(false);
  const [pendingUpdateData, setPendingUpdateData] = useState(null);
  const [fuelScopeOpen, setFuelScopeOpen] = useState(false);
  const {t} = useTranslation('navigation');

  const clearForm = {
    unit_id: 0,
    materials: [],
    material_cost_rate: null,
    billperunit: null,
    material_invoice_rate: null,
    contractor_rate_per_qty: null,
    contractor_rate_per_qty_special: null,
    contractors: [],
    driver_hourly_rate: null,
  };

  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: msg, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };

  const Summary = () => {
    setgetData(true);
    setSummaryOpen(true);
  };

  function handleUpdateJobClose() {
    setJob_id('');
    setEditJobBillingOpen(false);
  }

  async function handleUpdateJob(
    retroactive,
    og_billing,
    default_billing,
    special_billing,
    sendemailslater,
    conditional
  ) {
    try {
      const user_type = data ? data?.user_type : user?.user_type
      //console.log("JOB BILLING FOR THIS JOB: ",jsonGetById[0].job_billing)
      setValue('auto_invoice',autoInvoice)
      console.log('VALUESSS', JSON.parse(JSON.stringify(getValues())));
      //console.log(id)
      // return
      setOpenConfirm(false);
      setDisabled(true);
      let body = JSON.parse(JSON.stringify(getValues()));
      console.log('DATA', data);
      console.log('USER', user);
      body.retroactive = retroactive;
      body.og_billing = og_billing;
      body.default_billing = default_billing;
      body.special_billing = special_billing;
      body.user_id = data ? data.id : user?.company?.staff_id == '0' ? user?.user_id : user?.company?.staff_id;
      body.deletespecial = deletespecial;
      body.sendemails = !sendemailslater;
      body.conditional = conditional
      body.user_type = data ? data?.user_type : user?.user_type;
      //body = JSON.stringify(body);
      //open te summarry modal with no data
      retroactive == true ? setSummaryOpen(true) : null;

      if (commissionMatrixChanged && commissionMatrix?.length) {
        body['commissionMatrix'] = commissionMatrix
      }

      ButtonLog({button_name:'update_job_billing',type:'job',info:`job id: ${job_id ? job_id : id}, `+`${JSON.stringify(body)}`})

      const response = await client.put(
        `/jobs/job-billing/update/${job_id ? job_id : id}`,
        body,
        { timeout: 0 }
      );
      const res = await response.data;
      console.log('RES', res);

      if (res.error) {
        setDisabled(false);
        setSummaryOpen(false);
        setOpen(false);
        
        const errorMsg = res.error?.msg;
        
        // Check if this is the commissions validation error
        if (
          errorMsg &&
          errorMsg.includes(
            'Cannot change commissions because tickets already exist'
          )
        ) {
          // Store the update data to retry with override
          setPendingUpdateData({
            retroactive: retroactive || false,
            og_billing: og_billing || false,
            default_billing: default_billing || false,
            special_billing: special_billing || false,
            sendemailslater:
              sendemailslater !== undefined ? sendemailslater : true,
            conditional: conditional || [],
          });
          setCommissionsOverrideOpen(true);
          return;
        }
        
        _showMessage(errorMsg || 'An error occurred', 'error');
        return;
      }

      await saveFuelSurchargeOnUpdate();

      if (retroactive) {
        if (jobinvoices.comp.length > 0 || jobinvoices.sub.length > 0 || jobinvoices.op.length > 0) {
          _showMessage(
            `${t('BILLING_DETAILS_FOR_JOB')} ${
              jsonGetById[0].job_no 
            } ${t('WAS_SUCCESSFULLY_UPDATED_EDITED_COMPANY_INVOICES')} ${jobinvoices.comp.map((elem) => {
              return `${elem}`;
            })}
            , ${t('EDITED_SUBCONTRACTOR_INVOICES')} ${jobinvoices.sub.map((elem) => {
              return `${elem}`;
            })}
            , ${t('EDITED_OWNER_OPERATOR_INVOICES')} ${jobinvoices.op.map((elem) => {
              return `${elem}`;
            })}`,
            'success'
          );
        } else {
          _showMessage(
            `${t('BILLING_DETAILS_FOR_JOB')} ${jsonGetById[0].job_no} ${t('WERE_SUCCESSFULLY_UPDATED')}`, 
            'success'
          );
        }
        if(user_type != 'dispatcher')
        {
          getPendingJobs({compacctnum: data ? data?.compacctnum : user?.company?.compacctnum},(error) => {console.log('Error getting Pending Jobs When updating job billing: ',error)})
        }
        setgetData(true);
        reset(clearForm);
        setDisabled(false);
      } else {
        _showMessage(
          `${t('BILLING_DETAILS_FOR_JOB')} ${jsonGetById[0].job_no} ${t('WAS_SUCCESSFULLY_UPDATED')}`, //TODO improved message and need to replace ID for JOB Number.
          'success'
        );
        reset(clearForm);
        setDisabled(false);
        if(user_type != 'dispatcher')
        {
          getPendingJobs({compacctnum: data ? data?.compacctnum : user?.company?.compacctnum},(error) => {console.log('Error getting Pending Jobs When updating job billing: ',error)})
        }
        data ? handleUpdateJobClose() : history.push('/jobs');
      }
    } catch (error) {
      if (error.response?.status != 200) {
        setDisabled(false);
        setSummaryOpen(false);
        setOpen(false);
        setDisabled(false);
        
        const errorMsg = error.response?.data?.error?.msg;
        
        // Check if this is the commissions validation error
        if (
          errorMsg &&
          errorMsg.includes(
            'Cannot change commissions because tickets already exist'
          )
        ) {
          // Store the update data to retry with override
          setPendingUpdateData({
            retroactive: retroactive || false,
            og_billing: og_billing || false,
            default_billing: default_billing || false,
            special_billing: special_billing || false,
            sendemailslater:
              sendemailslater !== undefined ? sendemailslater : true,
            conditional: conditional || [],
          });
          setCommissionsOverrideOpen(true);
          return;
        }
        
        _showMessage(
          errorMsg
            ? errorMsg
            : t('UNEXPECTED_ERROR_OCURRED_PLEASE_TRY_AGAIN'),
          'error'
        );
        return;
      }
    }
  }

  async function saveFuelSurchargeOnUpdate() {
    const fuel = fuelSurchargeRef?.current;
    if (!fuel?.pendingOption || !fuelSurchargeWasModified(fuel)) return;
    const compacctnum = data ? data?.compacctnum : user?.company?.compacctnum;
    const jobNo = jsonGetById?.[0]?.job_no;
    const jobId = jsonGetById?.[0]?.job_info_id || job_id || id;
    try {
      await client.post('/jobs/job-fuel-surcharge', {
        compacctnum,
        job_no: Number(jobNo),
        job_id: Number(jobId),
        fsc_option_id: Number(fuel.fsc_option_id),
        rate: Number(fuel.rate),
        'fuel-surcharges-option': fuel.pendingOption,
      });
      fuel.initial = {
        rate: String(fuel.rate),
        fsc_option_id: String(fuel.fsc_option_id),
        hasSaved: true,
      };
      fuel.pendingOption = null;
    } catch (error) {
      _showMessage(error?.response?.data?.error || 'An error occurred', 'error');
    }
  }

  function confirmFuelSurchargeScope(option) {
    if (fuelSurchargeRef?.current) {
      fuelSurchargeRef.current.pendingOption = option;
    }
    setFuelScopeOpen(false);
    ReviewChanges(true);
  }

  async function ReviewChanges(fromFuelScope) {
    const fuel = fuelSurchargeRef?.current;
    if (fromFuelScope !== true && fuel) {
      fuel.pendingOption = null;
    }
    if (fuelSurchargeWasModified(fuel) && !fuel?.pendingOption) {
      if (!fuelSurchargeIsComplete(fuel)) {
        _showMessage('Rate and Calculated By are required', 'error');
        return;
      }
      setFuelScopeOpen(true);
      return;
    }

    //console.log("JOB BILLING FOR THIS JOB: ",jsonGetById[0].job_billing)
    //console.log("SPECIAL FOR THIS JOB: ",jsonGetById[1])

    //console.log(id)
    
      const new_values = JSON.parse(JSON.stringify(getValues()));
      console.log('NEW VALUES', new_values);
      const bill_per_unit = new_values.bill_invoice_rate;
      const cost_per_unit = new_values.billperunit;
      const {
        material_cost_rate,
        material_invoice_rate,
        driver_hourly_rate,
        taxable,
        material_broker,
        rate_owner,
        rate_sub,
      } = new_values;

      const obj_values = {
        material_cost_rate: Number(
          material_cost_rate ? material_cost_rate.replace(/[^0-9.-]+/g, '') : 0
        ),
        material_invoice_rate: Number(
          material_invoice_rate ? material_invoice_rate.replace(/[^0-9.-]+/g, '') : 0
        ),
        bill_per_unit: Number(bill_per_unit ? bill_per_unit.replace(/[^0-9.-]+/g, '') : 0),
        cost_per_unit: Number(cost_per_unit ? cost_per_unit.replace(/[^0-9.-]+/g, '') : 0),
        driver_hourly_rate: Number(
          driver_hourly_rate ? driver_hourly_rate.replace(/[^0-9.-]+/g, '') : 0
        ),
        taxable,
        material_broker,
      };

      const old_values = {
        material_cost_rate: jsonGetById[0].job_billing.material_cost_rate,
        material_invoice_rate: jsonGetById[0].job_billing.material_invoice_rate,
        bill_per_unit: jsonGetById[0].job_billing.bill_per_unit,
        cost_per_unit: jsonGetById[0].job_billing.cost_per_unit,
        driver_hourly_rate: jsonGetById[0].job_billing.driver_hourly_rate,
        taxable: jsonGetById[0].job_billing.taxable,
        material_broker: jsonGetById[0].job_billing.material_broker,
      };

      const new_default = {
        rate_owner: Number(rate_owner ? rate_owner.replace(/[^0-9.-]+/g, '') : 0),
        rate_sub: Number(rate_sub ? rate_sub.replace(/[^0-9.-]+/g, '') : 0),
      };
      const old_default = {
        rate_owner: jsonGetById[0].job_billing.rate_owner,
        rate_sub: jsonGetById[0].job_billing.rate_sub,
      };

      const old_special = jsonGetById[1].subcontractor;
      const new_special = new_values.subcontractor ? new_values.subcontractor : [];
      let new_cond = []

      // these flgs determine what will happens if user selects retroactive feature
      let og_billing = false; // job billing that affects only the og tickets
      let default_billing = false; // job billing that affects default sub and owp rates
      let special_billing = false; // job billing that affects special conditions

      //og_billing
      Object.keys(obj_values).map((key) => {
        if (old_values[key] != obj_values[key]) {
          if(key != 'material_invoice_rate' && key != 'bill_per_unit'){
            if(!new_cond.includes(1)){
              new_cond.push(1)
            }
          }
          if(key == 'material_invoice_rate' || key == 'bill_per_unit')
          {
            if(!new_cond.includes(0)){
              new_cond.push(0)
            }
          }

          og_billing = true;
        }
      });
      // if true open dialog
      //A change occured in the job billing XX invoices will be changed

      //default_billing
      Object.keys(new_default).map((key) => {
        if (old_default[key] != new_default[key]) {
          if(!new_cond.includes(1)){
            new_cond.push(1)
          }
          default_billing = true;
        }
      });
      // if true open dialog
      // A change occured in the default rates for OWPS and SUBS

      //if any special conditions are added or changed it will prompt user
      //special_billing
      if (!old_special && !new_special) {
        special_billing = false;
      } else if (!old_special && new_special) {
        if(!new_cond.includes(1)){
          new_cond.push(1)
        }
        special_billing = true;
      } else if (old_special && !new_special) {
        if(!new_cond.includes(1)){
          new_cond.push(1)
        }
        special_billing = true;
      } else if (old_special.length == new_special.length) {
        old_special.map((elem) => {
          const found = new_special.find((inst) => {
            if (
              inst.subcontractor_comp_id == elem.subcontractor_comp_id &&
              Number(inst.unit_rate ? inst.unit_rate : 0) ==
                Number(elem.unit_rate ? elem.unit_rate : 0)
            ) {
              return true;
            }
          });
          if (!found) {
            if(!new_cond.includes(1)){
              new_cond.push(1)
            }
            special_billing = true;
          }
        });
      } else if (old_special.length != new_special.length) {
        if(!new_cond.includes(1)){
          new_cond.push(1)
        }
        special_billing = true;
      }
      // if true open dialog
      // A change occured in the special conditions

      //do you want to retroactively update the tickets
      console.log(og_billing, default_billing, special_billing,new_cond);
      if (og_billing || default_billing || special_billing) {
        let res = [];

        setInvoicesPrev(true);
        const response = await client.post(
          `${constants.URLLOCAL}/invoices/invoices-by-tickets/${job_id ? job_id : id}`,
          { oldvalues: jsonGetById, newvalues: new_values,compacct: data ? data.compacctnum : user?.company?.compacctnum }
        );
        res = await response.data;
        res = res.result;
        setJobInvoices(res);
        console.log(res);
        setInvoicesPrev(false);
        /* const response = await fetch(`${constants.URLLOCAL}/invoices/invoices-by-jobid/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'token': `${token}`,
          },
        });
        res = await response.json()
        res = res.result
        setJobInvoices(res) */
        //console.log(res)

        console.log('opening popup with message');

        OpenRetroactivemodal({
          og_billing,
          default_billing,
          special_billing,
          invoices:{comp:res?.comp?.length,sub:res?.sub?.length,op:res?.op?.length},
          conditional:new_cond
         
        });
      } else {
        handleUpdateJob();
      }
    
  }

  async function OpenRetroactivemodal({ og_billing, default_billing, special_billing, invoices,conditional }) {
    let message =
      'Do you want the changes to affect all existing tickets in this job or only future ones?.'; //TODO improved message

    //if(default_billing)(message = message+`Owner Operator / Subcontractor Rates were edited. If you want to apply changes to all existing Owner Operator / Subcontractor tickets in this job click "APPLY CHANGES TO ALL" this will edit any invoices they have created. This only affects your Owner Operator / Subcontractor tickets. Otherwise apply changes going forward click "APPLY CHANGES GOING FORWARD".\n`)

    //if(special_billing)(message = message+`Owner Operator / Subcontractor Special Rates were edited. If you want to apply changes to all existing Owner Operator / Subcontractor tickets in this job click "APPLY CHANGES TO ALL" this will edit any invoices they have created. This only affects your Owner Operator / Subcontractor tickets. Otherwise apply changes going forward click "APPLY CHANGES GOING FORWARD".\n`)

    //if(og_billing){message = message+` Doing so will edit ${invoices} invoices`}

    setBillingChanges({ og_billing, default_billing, special_billing });
    setConditional(conditional)
    setBillingMessage(message);
    setChangingInvoices(invoices);
    setOpen(true);
    //on NO then just do normal updatejob
    //on YES send a flag "retroactive: true" and which aspects have changed "og_billing,default_billing,special_billing" on the update job function
    //in backend if flag is true then on og billing only get tickets that are og,
    // on default billing only edit tickets of subs and ops that dont appear on special cond list
    //on special billing only edit ticekts of subs and ops that appear on the special list
  }

  const [waitingCreateBilling, setWaitingCreateBilling] = useState(false);

  async function handleSaveJob() {
    try {
      const fuel = fuelSurchargeRef?.current;
      if (fuel?.enabled) {
        const compacctnum = data ? data?.compacctnum : user?.company?.compacctnum;
        const jobNo = jsonGetById?.[0]?.job_no;
        const jobId = jsonGetById?.[0]?.job_info_id || job_id || id;
        const rate = Number(fuel.rate);
        const fscOptionId = Number(fuel.fsc_option_id);
        if (
          compacctnum == null ||
          jobNo == null ||
          jobId == null ||
          !fscOptionId ||
          fuel.rate === '' ||
          Number.isNaN(rate)
        ) {
          _showMessage('Rate and Calculated By are required', 'error');
          return;
        }
      }

      const user_type = data ? data?.user_type : user?.user_type
      setValue('user_type', data ? data?.user_type : user?.user_type);
      setValue('customer_hauling', hasPermission('job-billing.read') && hasPermission('job-billing.browse') ? getValues('customer_hauling') : false);
      setValue('auto_invoice',autoInvoice)     

      console.log('VALUESSS', getValues());

      setDisabled(true);
      setWaitingCreateBilling(true)

      let payload = getValues()
      
      payload['user_id'] = data ? data.id : user?.company?.staff_id == '0' ? user?.user_id : user?.company?.staff_id;
      
      if (commissionMatrixChanged && commissionMatrix?.length) {
        payload['commissionMatrix'] = commissionMatrix
      }

      const response = await client.post(
        `${constants.URLLOCAL}/jobs/job-billing/new/${job_id ? job_id : id}`,
        payload
      );
      const res = await response.data;

      if (res?.error?.msg) {
        _showMessage(res.error.msg, 'error');
        setDisabled(false);
        setWaitingCreateBilling(false)
        return;
      }

      if (fuel?.enabled) {
        const compacctnum = data ? data?.compacctnum : user?.company?.compacctnum;
        const jobNo = jsonGetById?.[0]?.job_no;
        const jobId = jsonGetById?.[0]?.job_info_id || job_id || id;
        await client.post('/jobs/job-fuel-surcharge-record', {
          compacctnum,
          job_no: Number(jobNo),
          job_id: Number(jobId),
          fsc_option_id: Number(fuel.fsc_option_id),
          rate: Number(fuel.rate),
        });
      }

      _showMessage(
        `${t('SUCCESSFULLY_CREATED_BILLING_DETAILS_FOR_JOB')}${jsonGetById[0].job_no}.!`,
        'success'
      );
      reset(clearForm);
      setDisabled(false);
      if(user_type == 'dispatcher')
      {
        getPendingJobs({compacctnum: data ? data?.compacctnum : user?.company?.compacctnum},(error) => {console.log('Error getting Pending Jobs When creating job billing: ',error)})
      }
      data ? handleUpdateJobClose() : history.push('/jobs');
      setWaitingCreateBilling(false)
    } catch (error) {
      setWaitingCreateBilling(false)
      console.log(error);
      _showMessage(
        error.response?.data?.message || t('OH_PLEASE_TRY_AGAIN_SOMETHING_WENT_WRONG'),
        'error'
      );
      setDisabled(false);
    }
  }

  function handleCancelCreateJob() {
    data ? handleUpdateJobClose() : history.push('/jobs');
  }

  async function handleCommissionsOverride() {
    try {
      console.log('handleCommissionsOverride called', pendingUpdateData);
      
      if (!pendingUpdateData) {
        console.error('No pending update data available');
        setCommissionsOverrideOpen(false);
        _showMessage(t('UNEXPECTED_ERROR_OCURRED_PLEASE_TRY_AGAIN'), 'error');
        return;
      }
      
      // Log the override action
      await ButtonLog({
        type: 'job',
        button_name: 'job_billing_commissions_override_confirm',
        info: `Job ID: ${job_id ? job_id : id}`,
      });

      // Retry the update with override flag
      const user_type = data ? data?.user_type : user?.user_type;
      setCommissionsOverrideOpen(false);
      setDisabled(true);
      
      console.log('Retrying update with override flag', pendingUpdateData);

      let body = JSON.parse(JSON.stringify(getValues()));
      body.retroactive = pendingUpdateData.retroactive;
      body.og_billing = pendingUpdateData.og_billing;
      body.default_billing = pendingUpdateData.default_billing;
      body.special_billing = pendingUpdateData.special_billing;
      body.user_id = data ? data.id : user?.company?.staff_id == '0' ? user?.user_id : user?.company?.staff_id;
      body.deletespecial = deletespecial;
      body.sendemails = !pendingUpdateData.sendemailslater;
      body.conditional = pendingUpdateData.conditional;
      body.user_type = data ? data?.user_type : user?.user_type;
      body.override_commissions_validation = true; // Add override flag
      setValue('auto_invoice', autoInvoice);

      if (commissionMatrixChanged && commissionMatrix?.length) {
        body['commissionMatrix'] = commissionMatrix;
      }

      pendingUpdateData.retroactive == true ? setSummaryOpen(true) : null;
      const response = await client.put(
        `/jobs/job-billing/update/${job_id ? job_id : id}`,
        body,
        { timeout: 0 }
      );
      const res = await response.data;
      console.log('RES', res);

      if (res.error) {
        setDisabled(false);
        setSummaryOpen(false);
        setOpen(false);
        _showMessage(res.error.msg, 'error');
        setPendingUpdateData(null);
        return;
      }

      await saveFuelSurchargeOnUpdate();

      if (pendingUpdateData.retroactive) {
        if (
          jobinvoices.comp.length > 0 ||
          jobinvoices.sub.length > 0 ||
          jobinvoices.op.length > 0
        ) {
          _showMessage(
            `${t('BILLING_DETAILS_FOR_JOB')} ${jsonGetById[0].job_no} ${t(
              'WAS_SUCCESSFULLY_UPDATED_EDITED_COMPANY_INVOICES'
            )} ${jobinvoices.comp.map((elem) => {
              return `${elem}`;
            })}
            , ${t('EDITED_SUBCONTRACTOR_INVOICES')} ${jobinvoices.sub.map(
              (elem) => {
                return `${elem}`;
              }
            )}
            , ${t('EDITED_OWNER_OPERATOR_INVOICES')} ${jobinvoices.op.map(
              (elem) => {
                return `${elem}`;
              }
            )}`,
            'success'
          );
        } else {
          _showMessage(
            `${t('BILLING_DETAILS_FOR_JOB')} ${jsonGetById[0].job_no} ${t(
              'WERE_SUCCESSFULLY_UPDATED'
            )}`,
            'success'
          );
        }

        if (user_type != 'dispatcher') {
          getPendingJobs(
            {
              compacctnum: data
                ? data?.compacctnum
                : user?.company?.compacctnum,
            },
            (error) => {
              console.log(
                'Error getting Pending Jobs When updating job billing: ',
                error
              );
            }
          );
        }
        setgetData(true);
        reset(clearForm);
        setDisabled(false);
      } else {
        _showMessage(
          `${t('BILLING_DETAILS_FOR_JOB')} ${jsonGetById[0].job_no} ${t(
            'WAS_SUCCESSFULLY_UPDATED'
          )}`,
          'success'
        );
        reset(clearForm);
        setDisabled(false);
        if (user_type != 'dispatcher') {
          getPendingJobs(
            {
              compacctnum: data
                ? data?.compacctnum
                : user?.company?.compacctnum,
            },
            (error) => {
              console.log(
                'Error getting Pending Jobs When updating job billing: ',
                error
              );
            }
          );
        }
        data ? handleUpdateJobClose() : history.push('/jobs');
      }

      setPendingUpdateData(null);
    } catch (error) {
      console.error('Error in handleCommissionsOverride:', error);
      setDisabled(false);
      setCommissionsOverrideOpen(false);
      setPendingUpdateData(null);
      _showMessage(
        error.response?.data?.error?.msg
          ? error.response?.data?.error?.msg
          : t('UNEXPECTED_ERROR_OCURRED_PLEASE_TRY_AGAIN'),
        'error'
      );
    }
  }

  function handleCommissionsOverrideCancel() {
    setCommissionsOverrideOpen(false);
    setPendingUpdateData(null);
    setDisabled(false);
  }

  return (
    <div>

      <Dialog open={waitingCreateBilling}
      fullScreen
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}>
        <div className='flex flex-row items-center align-center justify-center w-full h-full'>
          <CircularLoader/>
        </div>
        
      </Dialog>

      <Dialog open={invoicesPrev}>
        <FuseLoading />
      </Dialog>
      <Dialog
        open={fuelScopeOpen}
        onClose={() => setFuelScopeOpen(false)}
        maxWidth={false}
        PaperProps={{ sx: { width: '100%', maxWidth: 452 } }}
        aria-labelledby='fuel-surcharge-scope-title'
      >
        <DialogTitle id='fuel-surcharge-scope-title' sx={{ fontSize: '1.875rem', fontWeight: 700 }}>
          Fuel Surcharges
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography sx={{ color: '#000', fontSize: '1.5rem', textAlign: 'center' }}>
            Are these changes retroactive or from this point forward?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
            <Button
              type='button'
              onClick={() => confirmFuelSurchargeScope('Retroactive')}
              sx={{
                backgroundColor: '#edca33',
                color: '#000',
                textTransform: 'none',
                fontSize: '1.3125rem',
                '&:hover': { backgroundColor: '#e9c917', color: '#000' },
              }}
            >
              Retroactive
            </Button>
            <Button
              type='button'
              onClick={() => confirmFuelSurchargeScope('From this point forward')}
              sx={{
                backgroundColor: '#edca33',
                color: '#000',
                textTransform: 'none',
                fontSize: '1.3125rem',
                '&:hover': { backgroundColor: '#e9c917', color: '#000' },
              }}
            >
              From this point forward
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <RetroactiveUpdateModal
        open={open}
        setOpen={setOpen}
        confirmopen={openconfirm}
        setConfirmOpen={setOpenConfirm}
        billingmessage={billingmessage}
        billingchanges={billingchanges}
        conditional={conditional}
        changinginvoices={changinginvoices}
        handleUpdateJob={handleUpdateJob}
      />

      <SummaryModal
        setJob_id={setJob_id}
        setEditJobBillingOpen={setEditJobBillingOpen}
        data={data}
        open={SummaryOpen}
        setOpen={setSummaryOpen}
        getData={getData}
        id={id}
      />

      <CommissionsOverrideModal
        open={commissionsOverrideOpen}
        setOpen={setCommissionsOverrideOpen}
        onConfirm={handleCommissionsOverride}
        onCancel={handleCommissionsOverrideCancel}
      />

      <motion.div
        className={(!hasPermission('job-billing.read') && hasPermission('job-billing.browse')) || jsonGetById[0]?.bol_type == true && jsonGetById[0]?.bol_jb == false ? "flex sm:flex-row mb-32 right buttons w-100 justify-start mr-14" : "flex sm:flex-row mb-32 right buttons w-100 justify-end"}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}
      >
        <div>
          <div className="bottombtns flex">
            <div className="new-job-btn">
              <button onClick={handleCancelCreateJob}>{t('CANCEL')}</button>
            </div>
            <div className="new-job-btn">
              <button
                onClick={
                  localStorage.getItem('job_duplicate') ? 
                  handleSaveJob
                  :
                  jsonGetById.length > 0
                    ? jsonGetById[0].job_billing
                      ? ReviewChanges
                      : handleSaveJob
                    : null
                }
              >
                {
                  localStorage.getItem('job_duplicate') ?
                  t('CREATE')
                  :
                jsonGetById.length > 0
                  ? jsonGetById[0].job_billing
                    ? t('UPDATE')
                    : t('CREATE')
                  : t('CREATE')}
              </button>
            </div>
          </div>
        </div>
      </motion.div>
      {jsonGetById.length > 0 && jsonGetById[0].job_billing && (jsonGetById[0]?.bol_type == false || (jsonGetById[0]?.bol_type == true && jsonGetById[0]?.bol_jb == true)) ? (
        <div className="flex flex-col pt-64">
          <BillingHistory
            job_id={job_id}
            data={data}
            id={id}
          />
        </div>
      ) : null}
      <div ref={job_billing_history} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getPendingJobs: (payload, onError) => dispatch(JobAction.getPendingJobs(payload, onError)),
})

const mapStateToProps = (state) => {
  return {
    user: state?.loadz_auth?.AuthReducer?.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobsHelpersFooterBilling);
